module.exports = __webpack_public_path__ + "img/57.480a3a25.jpg";